// AUTO-GENERATED — docs/infrastructure/{Výkresy,Barvy}.xlsx → scripts/generate-workflows.py
// Needit ručně. Při změně Excelu spusť: python scripts/generate-workflows.py

import type { GeneratedWorkflow } from './generated-types';

export const GENERATED_WORKFLOWS: GeneratedWorkflow[] = [
  {
    id: 'VYKOP.1',
    objectType: 'VYKOP',
    frontendName: 'Výkop',
    phases: [
      { index: 0, code: 'VYKOP.1.PHASE.0', name: 'Nevykopaný', colors: { general: 'RED', stavba: 'RED', montaz: 'RED', zafuk: 'RED', optika: null } },
      { index: 1, code: 'VYKOP.1.PHASE.1', name: 'Vykopaný', colors: { general: 'ORANGE', stavba: 'ORANGE', montaz: 'ORANGE', zafuk: 'ORANGE', optika: null } },
      { index: 2, code: 'VYKOP.1.PHASE.2', name: 'Finální', colors: { general: 'YELLOW', stavba: 'YELLOW', montaz: 'GREEN', zafuk: 'GREEN_TRANSPARENT', optika: null } },
      { index: 3, code: 'VYKOP.1.PHASE.3', name: 'Předaný', colors: { general: 'GREEN', stavba: 'GREEN', montaz: 'GREEN', zafuk: 'GREEN_TRANSPARENT', optika: null } },
    ],
  },
  {
    id: 'STAVAJICI.1',
    objectType: 'STAVAJICI',
    frontendName: 'Stávájící HDPE',
    phases: [
      { index: 0, code: 'STAVAJICI.1.PHASE.0', name: 'Stávající', colors: { general: 'BLUE_TRANSPARENT', stavba: 'BLUE_TRANSPARENT', montaz: 'BLUE_TRANSPARENT', zafuk: 'BLUE_TRANSPARENT', optika: null } },
    ],
  },
  {
    id: 'ROZVADEC.1',
    objectType: 'ROZVADEC',
    frontendName: 'Rozvaděč',
    phases: [
      { index: 0, code: 'ROZVADEC.1.PHASE.0', name: 'Nezačaté', colors: { general: 'RED', stavba: 'RED', montaz: 'RED', zafuk: 'RED', optika: 'RED' } },
      { index: 1, code: 'ROZVADEC.1.PHASE.1', name: 'Postavený', colors: { general: 'ORANGE', stavba: 'GREEN', montaz: 'GREEN', zafuk: 'ORANGE', optika: 'RED' } },
      { index: 2, code: 'ROZVADEC.1.PHASE.2', name: 'Zafouknutý', colors: { general: 'YELLOW', stavba: 'GREEN', montaz: 'GREEN', zafuk: 'GREEN', optika: 'ORANGE' } },
      { index: 3, code: 'ROZVADEC.1.PHASE.3', name: 'Svařený', colors: { general: 'GREEN', stavba: 'GREEN', montaz: 'GREEN', zafuk: 'GREEN', optika: 'GREEN' } },
    ],
  },
  {
    id: 'BUDOVA.1',
    objectType: 'BUDOVA',
    frontendName: 'Budova',
    phases: [
      { index: 0, code: 'BUDOVA.1.PHASE.0', name: 'Nepřipojený', colors: { general: 'RED', stavba: 'RED', montaz: 'RED', zafuk: 'RED', optika: 'RED' } },
      { index: 1, code: 'BUDOVA.1.PHASE.1', name: 'Zrušený', colors: { general: 'BLACK', stavba: 'BLACK', montaz: 'BLACK', zafuk: 'BLACK', optika: 'BLACK' } },
    ],
  },
  {
    id: 'BUDOVA.2',
    objectType: 'BUDOVA',
    frontendName: 'Budova',
    phases: [
      { index: 0, code: 'BUDOVA.2.PHASE.0', name: 'Nepřipojený', colors: { general: 'RED', stavba: 'RED', montaz: 'RED', zafuk: 'RED', optika: 'RED' } },
      { index: 1, code: 'BUDOVA.2.PHASE.1', name: 'Připojené plasty', colors: { general: 'ORANGE', stavba: 'GREEN', montaz: 'GREEN', zafuk: 'ORANGE', optika: 'RED' } },
      { index: 2, code: 'BUDOVA.2.PHASE.2', name: 'Zafouknutý', colors: { general: 'YELLOW', stavba: 'GREEN', montaz: 'GREEN', zafuk: 'GREEN', optika: 'ORANGE' } },
      { index: 3, code: 'BUDOVA.2.PHASE.3', name: 'Svařený', colors: { general: 'GREEN', stavba: 'GREEN', montaz: 'GREEN', zafuk: 'GREEN', optika: 'GREEN' } },
    ],
  },
  {
    id: 'BUDOVA.3',
    objectType: 'BUDOVA',
    frontendName: 'Budova',
    phases: [
      { index: 0, code: 'BUDOVA.3.PHASE.0', name: 'Nepřipojený', colors: { general: 'RED', stavba: 'RED', montaz: 'RED', zafuk: 'RED', optika: 'RED' } },
      { index: 1, code: 'BUDOVA.3.PHASE.1', name: 'Postavená bábovka', colors: { general: 'ORANGE', stavba: 'GREEN', montaz: 'GREEN', zafuk: 'ORANGE', optika: 'ORANGE' } },
      { index: 2, code: 'BUDOVA.3.PHASE.2', name: 'Zafouknutý', colors: { general: 'GREEN', stavba: 'GREEN', montaz: 'GREEN', zafuk: 'GREEN', optika: 'GREEN' } },
    ],
  },
  {
    id: 'SPOJKOVISTE.1',
    objectType: 'SPOJKOVISTE',
    frontendName: 'Spojkoviště',
    phases: [
      { index: 0, code: 'SPOJKOVISTE.1.PHASE.0', name: 'Nepřipojené', colors: { general: 'RED', stavba: 'RED', montaz: 'RED', zafuk: 'RED', optika: null } },
      { index: 1, code: 'SPOJKOVISTE.1.PHASE.1', name: 'Připojené', colors: { general: 'GREEN', stavba: 'GREEN', montaz: 'GREEN', zafuk: 'GREEN', optika: null } },
    ],
  },
  {
    id: 'JAMA.1',
    objectType: 'JAMA',
    frontendName: 'Montážní jáma',
    phases: [
      { index: 0, code: 'JAMA.1.PHASE.0', name: 'Nevykopaná', colors: { general: 'RED', stavba: 'RED', montaz: 'RED', zafuk: null, optika: null } },
      { index: 1, code: 'JAMA.1.PHASE.1', name: 'Vykopaná', colors: { general: 'ORANGE', stavba: 'ORANGE', montaz: 'ORANGE', zafuk: null, optika: null } },
      { index: 2, code: 'JAMA.1.PHASE.2', name: 'Finální', colors: { general: 'GREEN', stavba: 'GREEN', montaz: 'GREEN', zafuk: null, optika: null } },
    ],
  },
  {
    id: 'INFO.1',
    objectType: 'INFO',
    frontendName: 'Info',
    phases: [
      { index: 0, code: 'INFO.1.PHASE.0', name: 'Info', colors: { general: 'GRAY', stavba: 'GRAY', montaz: 'GRAY', zafuk: 'GRAY', optika: 'GRAY' } },
    ],
  },
  // Hand-maintained until docs/infrastructure Barvy.xlsx includes this type (xlsx not committed).
  {
    id: 'KONCOVYBOD.1',
    objectType: 'KONCOVYBOD',
    frontendName: 'Koncový bod záfuku',
    phases: [
      { index: 0, code: 'KONCOVYBOD.1.PHASE.0', name: 'Nezafouknuto', colors: { general: 'RED', stavba: null, montaz: null, zafuk: 'RED', optika: null } },
      { index: 1, code: 'KONCOVYBOD.1.PHASE.1', name: 'Zafouknuto', colors: { general: 'GREEN', stavba: null, montaz: null, zafuk: 'GREEN', optika: null } },
    ],
  },
];
